import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/mobile_shop_by_brand';

export default function MobileShopByBrand() {
  return (
    <>
      <PageTemplate type={true}>
        <Container />
      </PageTemplate>
    </>
  );
}
